import { getEquipmentManual } from "actions/customerEquipment";
import { getJobMediaByJobID, downloadJobMedia } from "actions/job";
import React, { useEffect, useState } from "react";
import { Card, Col, Row, TabPane } from "reactstrap";

const MediaAndDocuments = ({
  activeTab,
  setSelectedImage,
  setSelectedPDF,
  setSelectedVideo,
  handleFileDownload,
  decodedId,
  notify,
}) => {
  const [equipmentData, setequipmentData] = useState([]);
  const [jobMediaData, setjobMediaData] = useState([]);
  const [isDownloading, setIsDownloading] = useState(false);

  const getEquimentManuals = async () => {
    try {
      const res = await getEquipmentManual(decodedId);
      if (res?.code === 200) {
        setequipmentData(res?.data);
      }
    } catch (error) {
      console.log("error", error?.message);
    }
  };

  const getJobMedia = async () => {
    try {
      const res = await getJobMediaByJobID(decodedId);
      if (res?.code === 200) {
        setjobMediaData(res?.data);
      }
    } catch (error) {
      console.log("error", error?.message);
    }
  };

  useEffect(() => {
    if (activeTab === "media" && decodedId) {
      getEquimentManuals();
      getJobMedia();
    }
  }, [activeTab, decodedId]);

  const handleDownloadMedia = async (mediaID, techinicalReportID) => {
    setIsDownloading(true);
    try {
      const res = await downloadJobMedia(mediaID, techinicalReportID);
      if (res.status === 200 && res.data) {
        const fileName =
          res.headers["content-disposition"]?.match(/filename="(.+?)"/)?.[1];
        const url = URL.createObjectURL(res.data);
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        a.click();
        URL.revokeObjectURL(url);
      } else if (res.code === 404) {
        notify("danger", res?.message || "Media not found.");
      } else {
        notify(
          "danger",
          res?.message || "Failed to download media. Please try again.",
        );
      }
    } catch (error) {
      notify(
        "danger",
        error?.message || "Failed to download media. Please try again.",
      );
    }
    setIsDownloading(false);
  };

  return (
    <TabPane tabId="media">
      {isDownloading && (
        <div className="logout-overlay">
          <div className="logout-card">
            <i className="fa fa-spinner fa-spin fa-2x text-deep-blue mb-3" />
            <div className="font-weight-bold text-dark">
              Downloading… Please wait.
            </div>
          </div>
        </div>
      )}
      <Row>
        <Col md="6">
          <Card className="rounded border-0 mb-4 px-4 py-3 custom-card">
            <h4 className="mb-3 text-default">Images/Videos By Client</h4>
            <div className="border-bottom border-muted mb-3" />
            <Row>
              <Col>
                {jobMediaData?.jobMediaByClient?.length > 0 ? (
                  <div className="media-grid">
                    {jobMediaData?.jobMediaByClient?.map((img) => {
                      const src = img?.imageOrVIDeoPath;
                      const isPdf =
                        typeof src === "string" &&
                        src.toLowerCase().endsWith(".pdf");
                      const isVideo =
                        typeof src === "string" &&
                        [".mp4", ".mov", ".m4v", ".avi", ".mkv"].some((ext) =>
                          src.toLowerCase().endsWith(ext),
                        );
                      return (
                        <div
                          key={img.ID}
                          className="media-card"
                          onClick={() =>
                            isVideo
                              ? setSelectedVideo(src)
                              : isPdf
                                ? setSelectedPDF(src)
                                : setSelectedImage(src)
                          }
                        >
                          <div className="media-preview-wrapper">
                            {isVideo ? (
                              <video
                                src={src}
                                className="media-preview"
                                muted
                                controls
                              />
                            ) : isPdf ? (
                              <iframe
                                src={src}
                                // title={img.title}
                                className="pdf-preview"
                              ></iframe>
                            ) : (
                              <img
                                src={src}
                                alt="product"
                                className="media-preview"
                              />
                            )}
                          </div>
                          <div className="media-info">
                            {/* <div className="media-title text-truncate">
                              Product Image {img.ID}
                            </div> */}
                            <div className="uploaded-date">
                              <div className="date-row">
                                <i className="fa fa-calendar-alt date-icon" />
                                <span className="uploaded-label">
                                  Uploaded Date:
                                </span>
                                <span className="date-line">
                                  {img?.createdAt
                                    ?.split(/\d{2}:\d{2}\s(?:AM|PM)/)[0]
                                    ?.trim()}
                                </span>
                              </div>

                              <div className="time-line">
                                {
                                  img?.createdAt?.match(
                                    /\d{2}:\d{2}\s(?:AM|PM)/,
                                  )?.[0]
                                }
                              </div>
                            </div>
                            <div
                              className="media-actions"
                              onClick={(e) => e.stopPropagation()}
                            >
                              <span
                                className="link-action view-link"
                                onClick={() =>
                                  isVideo
                                    ? setSelectedVideo(src)
                                    : isPdf
                                      ? setSelectedPDF(src)
                                      : setSelectedImage(src)
                                }
                              >
                                <i className="fa fa-eye mr-1" /> View
                              </span>
                              <span
                                className="link-action download-link"
                                onClick={() =>
                                  handleDownloadMedia(
                                    img?.ID,
                                    img?.technicalReportID || 0,
                                  )
                                }
                              >
                                <i className="fa fa-download mr-1" /> Download
                              </span>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <div className="text-center text-muted py-4">
                    No Images/Videos Uploaded by Client
                  </div>
                )}
              </Col>
            </Row>
          </Card>
        </Col>

        <Col md="6">
          <Card className="rounded mb-4 px-4 py-3 custom-card">
            <Row className="align-items-center mb-2">
              <Col>
                <h4 className="text-default mb-0">
                  Images/Videos By Technician
                </h4>
              </Col>
            </Row>

            <div className="border-bottom border-muted mb-3" />

            <Row>
              <Col>
                {jobMediaData?.jobMediaByTechnician?.length > 0 ? (
                  <div className="media-grid">
                    {jobMediaData?.jobMediaByTechnician?.map((img) => {
                      const src = img?.imageOrVIDeoPath;
                      const isPdf =
                        typeof src === "string" &&
                        src.toLowerCase().endsWith("pdf");
                      const isVideo =
                        typeof src === "string" &&
                        [".mp4", ".mov", ".m4v", ".avi", ".mkv"].some((ext) =>
                          src.toLowerCase().endsWith(ext),
                        );

                      return (
                        <div
                          key={img.ID}
                          className="media-card"
                          onClick={() =>
                            isVideo
                              ? setSelectedVideo(src)
                              : isPdf
                                ? setSelectedPDF(src)
                                : setSelectedImage(src)
                          }
                        >
                          <div className="media-preview-wrapper">
                            {isVideo ? (
                              <video
                                src={src}
                                className="media-preview"
                                muted
                                controls
                              />
                            ) : isPdf ? (
                              <iframe
                                src={src}
                                // title={img.title}
                                className="pdf-preview"
                              ></iframe>
                            ) : (
                              <img
                                src={src}
                                alt="product"
                                className="media-preview"
                              />
                            )}
                          </div>
                          <div className="media-info">
                            <div className="uploaded-date">
                              <div className="date-row">
                                <i className="fa fa-calendar-alt date-icon" />
                                <span className="uploaded-label">
                                  Uploaded Date:
                                </span>
                                <span className="date-line">
                                  {img?.createdAt
                                    ?.split(/\d{2}:\d{2}\s(?:AM|PM)/)[0]
                                    ?.trim()}
                                </span>
                              </div>

                              <div className="time-line">
                                {
                                  img?.createdAt?.match(
                                    /\d{2}:\d{2}\s(?:AM|PM)/,
                                  )?.[0]
                                }
                              </div>
                            </div>

                            <div
                              className="media-actions"
                              onClick={(e) => e.stopPropagation()}
                            >
                              <span
                                className="link-action view-link"
                                onClick={() =>
                                  isVideo
                                    ? setSelectedVideo(src)
                                    : isPdf
                                      ? setSelectedPDF(src)
                                      : setSelectedImage(src)
                                }
                              >
                                <i className="fa fa-eye mr-1" /> View
                              </span>

                              <span
                                className="link-action download-link"
                                onClick={() =>
                                  handleDownloadMedia(
                                    img?.ID,
                                    img?.technicalReportID || 0,
                                  )
                                }
                              >
                                <i className="fa fa-download mr-1" /> Download
                              </span>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <div className="text-center text-muted py-4">
                    No Images/Videos Uploaded by Technician
                  </div>
                )}
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col md="6">
          <Card className="rounded border-0 mb-4 px-4 py-3 custom-card">
            <h4 className="mb-3 text-default">Files Uploaded By Admin</h4>
            <div className="border-bottom border-muted mb-3" />
            <Row>
              <Col>
                {jobMediaData?.jobMediaByAdmin?.length > 0 ? (
                  <div className="media-grid">
                    {jobMediaData?.jobMediaByAdmin?.map((img) => {
                      const src = img?.imageOrVIDeoPath;
                      const isPdf =
                        typeof src === "string" &&
                        src.toLowerCase().endsWith("pdf");
                      const isVideo =
                        typeof src === "string" &&
                        [".mp4", ".mov", ".m4v", ".avi", ".mkv"].some((ext) =>
                          src.toLowerCase().endsWith(ext),
                        );

                      return (
                        <div
                          key={img.ID}
                          className="media-card"
                          onClick={() =>
                            isVideo
                              ? setSelectedVideo(src)
                              : isPdf
                                ? setSelectedPDF(src)
                                : setSelectedImage(src)
                          }
                        >
                          <div className="media-preview-wrapper">
                            {isVideo ? (
                              <video
                                src={src}
                                className="media-preview"
                                muted
                                controls
                              />
                            ) : isPdf ? (
                              <iframe
                                src={src}
                                // title={img.title}
                                className="pdf-preview"
                              ></iframe>
                            ) : (
                              <img
                                src={src}
                                alt="product"
                                className="media-preview"
                              />
                            )}
                          </div>
                          <div className="media-info">
                            {/* <div className="media-title text-truncate">
                            Product Image {img?.ID}
                          </div> */}
                            <div className="uploaded-date">
                              <div className="date-row">
                                <i className="fa fa-calendar-alt date-icon" />
                                <span className="uploaded-label">
                                  Uploaded Date:
                                </span>
                                <span className="date-line">
                                  {img?.createdAt
                                    ?.split(/\d{2}:\d{2}\s(?:AM|PM)/)[0]
                                    ?.trim()}
                                </span>
                              </div>

                              <div className="time-line">
                                {
                                  img?.createdAt?.match(
                                    /\d{2}:\d{2}\s(?:AM|PM)/,
                                  )?.[0]
                                }
                              </div>
                            </div>
                            <div
                              className="media-actions"
                              onClick={(e) => e.stopPropagation()}
                            >
                              <span
                                className="link-action view-link"
                                onClick={() =>
                                  isVideo
                                    ? setSelectedVideo(src)
                                    : isPdf
                                      ? setSelectedPDF(src)
                                      : setSelectedImage(src)
                                }
                              >
                                <i className="fa fa-eye mr-1" /> View
                              </span>
                              <span
                                className="link-action download-link"
                                onClick={() =>
                                  handleDownloadMedia(
                                    img?.ID,
                                    img?.technicalReportID || 0,
                                  )
                                }
                              >
                                <i className="fa fa-download mr-1" /> Download
                              </span>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <div className="text-center text-muted py-4">
                    No Files Uploaded By Admin
                  </div>
                )}
              </Col>
            </Row>
          </Card>
        </Col>

        <Col md="6">
          <Card className="rounded border-0 mb-4 px-4 py-3 shadow-sm custom-card">
            <h4 className="mb-3 text-default">Equipment Manual</h4>
            <div className="border-bottom border-muted mb-3" />
            {equipmentData?.productDocuments?.length > 0 &&
              equipmentData?.productDocuments?.map((item, index) => (
                <div
                  key={index}
                  className="hover-lift rounded p-3 mb-3 d-flex flex-wrap align-items-center justify-content-between"
                >
                  <div className="col-md-9 mb-2 mb-md-0">
                    <span className="small text-muted d-block mb-1">
                      File Name
                    </span>
                    <span className="small-text">
                      {item.document_title || "-"}
                    </span>
                  </div>

                  <div
                    className="col-md-3 text-md-end text-start text-default pointer"
                    onClick={() =>
                      handleFileDownload("equipment_manual", item?.id)
                    }
                  >
                    <i className="fa fa-download mr-1" />
                    Download
                  </div>
                </div>
              ))}
            {(!equipmentData?.productDocuments ||
              equipmentData?.productDocuments?.length === 0) && (
              <div className="text-center text-muted py-4">
                No Equipment Manuals Available
              </div>
            )}
          </Card>
        </Col>
      </Row>
    </TabPane>
  );
};

export default MediaAndDocuments;
